import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import CivilImg1 from '../../assest/Civil-1.png';
import CivilImg2 from '../../assest/Civil-2.png';
import CivilImg3 from '../../assest/Civil-3.png';

const civilTechniciansList = [
  {
    name: "Site Supervisor",
    image: CivilImg1,
    specs: "Oversees day-to-day construction site activities.",
    description: "Ensures safety standards, supervises laborers, and coordinates between teams and contractors.",
  },
  {
    name: "Structural Inspector",
    image: CivilImg2,
    specs: "Inspects infrastructure for integrity and compliance.",
    description: "Specialist in assessing foundations, frameworks, and overall structural soundness.",
  },
  {
    name: "Survey Technician",
    image: CivilImg3,
    specs: "Land surveying and measurements for construction planning.",
    description: "Uses tools and maps to ensure accurate groundwork and layout for projects.",
  },
];

const translations = {
  gb: {
    heading: "Civil Technician Services",
    introText: "Find qualified civil technicians for site management, inspections, and surveying.",
    categoriesTitle: "Available Civil Technicians",
    featuredTitle: "Top Civil Technicians",
    featuredDescription: "Experienced professionals to support your construction and infrastructure projects.",
  },
  sa: {
    heading: "خدمات الفنيين المدنيين",
    introText: "اعثر على فنيين مدنيين مؤهلين لإدارة المواقع والفحص والمسح.",
    categoriesTitle: "الفنيون المدنيون المتاحون",
    featuredTitle: "أفضل الفنيين المدنيين",
    featuredDescription: "محترفون ذو خبرة لدعم مشاريعك الإنشائية والبنية التحتية.",
  },
};

const CivilTechnicians = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={civilTechniciansList}
      language={language}
    />
  );
};

export default CivilTechnicians;
